export default __webpack_public_path__ + "static/media/whiptrip6.6d9077ae.png";